import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Popover} from 'react-bootstrap'
import {connectForm} from '../../core/redux/form'
import phonez, {phoneField} from '../../core/phonez'
import Icon from '../../core/components/Icon'
import {ADD_CONTACT_CMD_UPDATED, sendAddContactCmd, sendRemoveContactCmd, loadContact} from '../actions'
import {createValidator, AddContactCmd} from '../models'
import i18n from '../i18n'
import style from './AddRemoveContactPopover.less'

class AddRemoveContactPopover extends Component {

    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    _sendAddCmd(event) {
        const {dispatch, onHide} = this.props

        event.preventDefault()
        
        return dispatch(sendAddContactCmd()).then(() => {
            return dispatch(loadContact())
        })
    }

    _sendRemoveCmd(event, medium) {
        const {dispatch} = this.props

        event.preventDefault()
        
        return dispatch(sendRemoveContactCmd(medium)).then(() => {
            return dispatch(loadContact())
        })
    }

    render() {
        const {dispatch, form, cmd, contact, onHide, ...others} = this.props

        const mediumField = (field, type) => {
            var value

            switch(type) {
                case 'Phone':
                    value = field.value && field.value.phone
                    break
                case 'Mail':
                    value = field.value && field.value.mail
                    break
                case 'Fax':
                    value = field.value && field.value.fax
                    break
            }

            function onChange(eventOrValue) {
                var value
                if (eventOrValue && eventOrValue.target) {
                    value = eventOrValue.target.value
                } else {
                    value = eventOrValue
                }

                var medium
                switch(type) {
                    case 'Phone':
                        medium = value && {phone: value, contactInfoType: 'Phone'} || null
                        break
                    case 'Mail':
                        medium = value && {mail: value, contactInfoType: 'Mail'} || null
                        break
                    case 'Fax':
                        medium = value && {fax: value || null, contactInfoType: 'Fax'} || null
                        break
                }

                field.onChange(medium)
            }

            return {...field, value, onChange}
        }

        const inputButton = (type) => (
            <Button
                disabled={(cmd && cmd.contact && cmd.contact.contactInfoType != type) || !form.isValid()}
                onClick={(e) => this._sendAddCmd(e)}>
                <Icon icon='plus' size='xs' />
            </Button>
        )

        return (
            <Popover
                title={i18n.contacts}
                {...others}>
                <h5>{i18n.phone}</h5>
                <ul className={style.contactGroup}>
                    {contact.contacts.filter((m) => m.contactInfoType == 'Phone').map((medium, index) => (
                        <li key={index}>
                            <a
                                href=''
                                className={style.remove}
                                onClick={(e) => this._sendRemoveCmd(e, medium)}>
                                <Icon icon='minus' size='xs' />
                            </a>
                            <p>{phonez(medium.phone).format()}</p>
                        </li>
                    ))}
                </ul>
                <form>
                    <Input
                        type='text'
                        name='phone'
                        buttonAfter={inputButton('Phone')}
                        {...phoneField(mediumField(form.contact(), 'Phone'))} />
                </form>
                <h5>{i18n.email}</h5>
                <ul className={style.contactGroup}>
                    {contact.contacts.filter((m) => m.contactInfoType == 'Mail').map((medium, index) => (
                        <li key={index}>
                            <a
                                href=''
                                className={style.remove}
                                onClick={(e) => this._sendRemoveCmd(e, medium)}>
                                <Icon icon='minus' size='xs' />
                            </a>
                            <p>{medium.mail}</p>
                        </li>
                    ))}
                </ul>
                <form>
                    <Input
                        type='text'
                        name='phone'
                        buttonAfter={inputButton('Mail')}
                        {...mediumField(form.contact(), 'Mail')} />
                </form>
                <h5>{i18n.fax}</h5>
                <ul className={style.contactGroup}>
                    {contact.contacts.filter((m) => m.contactInfoType == 'Fax').map((medium, index) => (
                        <li key={index}>
                            <a
                                href=''
                                className={style.remove}
                                onClick={(e) => this._sendRemoveCmd(e, medium)}>
                                <Icon icon='minus' size='xs' />
                            </a>
                            <p>{phonez(medium.fax).format()}</p>
                        </li>
                    ))}
                </ul>
                <form>
                    <Input
                        type='text'
                        name='phone'
                        buttonAfter={inputButton('Fax')}
                        {...phoneField(mediumField(form.contact(), 'Fax'))} />
                </form>
                <ButtonToolbar>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </Popover>
        )
    }
}

AddRemoveContactPopover = connectForm({
    validator: createValidator(),
    target: 'cmd',
    schema: AddContactCmd.schema,
    action: ADD_CONTACT_CMD_UPDATED
})(AddRemoveContactPopover)

AddRemoveContactPopover = connect((state) => ({
    contact: state.patrimony.contact.contact,
    cmd: state.patrimony.addContactCmd
}))(AddRemoveContactPopover)

export default AddRemoveContactPopover


// WEBPACK FOOTER //
// ./lib/patrimony/components/AddRemoveContactPopover.js